import { createContext, useContext, useRef } from "react";

const ArtistContext = createContext(null);

function getArtistId(a) {
  return a?.id ?? a?.artist_id ?? null;
}

export function ArtistProvider({ children }) {
  const artistsRef = useRef(new Map());

  function upsertArtist(artist) {
    const id = getArtistId(artist);
    if (!id) return;
    artistsRef.current.set(id, artist);
  }

  function getArtist(id) {
    if (!id) return null;
    return artistsRef.current.get(id) || null;
  }

  return (
    <ArtistContext.Provider value={{ upsertArtist, getArtist }}>
      {children}
    </ArtistContext.Provider>
  );
}

export function useArtists() {
  return useContext(ArtistContext);
}
